export default {
  data() {
    return {
      Price:'',
      showPrice:"",
      showPriceText:"",
      url: {
        getWarehouseUrl: SZH.assets.api + "/WareHouse/GetSelectWareHouseForWeb",
        GetSelectProductMaterielTypeForWebUrl: SZH.assets.api + "/Product/GetSelectProductMaterielTypeForWeb",//分类
        GetSelectProductMaterielForWebUrl: SZH.assets.api + "/Product/GetSelectProductMaterielForWeb ",//物料
        GetPagingProductInfoForWebUrl: SZH.assets.api + "/Product/GetPagingProductInfoForWeb ",//列表
        CheckProductPassTimeForWeb: SZH.assets.api + "/Product/CheckProductPassTimeForWeb ",//判断
        GetSelectProductBusinessType: SZH.assets.api + "/Product/GetSelectProductBusinessType",//获得业务类型
        SelectItems: SZH.assets.api + "/ItemType/SelectItems ",//获得业务类型 2021/12/14 10:00 am
        SendVerifyCodeForWeb: SZH.assets.api + "/Custom/SendVerifyCodeForWeb ",//发送验证码
        CheckVerifyCodeForProductPassTime: SZH.assets.api + "/Custom/CheckVerifyCodeForProductPassTime",//保存
        GetCustomAuthType:SZH.assets.api + '/Custom/GetCustomAuthType2',//是否进行过认证 2021/12/24 更改
        GetSystemConfigure:SZH.assets.api + '/Market/GetSystemConfigure',//价格 2021/12/24 更改
      },
      form: {
        Keyword: "",
        WareHouseId: "",
        MaterielTypeId: "",
        MaterielId: "",
        BusinessType: "1",
        PriceSortType: "desc",//asc升序
      },
      WarHouseOption: [],
      BusinessOptions: [],
      MaterielTypeOption: [],
      MaterielOption: [],
      productList: [],
      currentpage: 1,
      pageSize: 20,
      TotalCount: 0,
      UserPhone: "15253645959",
      VCode: "",
      sendVCodeTime: "",
      fullscreenLoading: false,
      dialogVisible: false,
      WareHouseIdCh: "2000",
    };
  },
  methods: {
    //2021/12/24 价格显示相关
    GetCustomAuthType(){
      let self = this
      self.$http.post(self.url.GetCustomAuthType,{}).then(result=>{
        if(result.state == 1){
          self.Price = result.data
          if(result.data != 1){
            self.GetSystemConfigure("AuthCompanyPrice")
          }
        }
      })
    },
    GetSystemConfigure(val){
      let self = this
      self.$http.post(self.url.GetSystemConfigure,{
        keyValue:val
      }).then(result=>{
        if(result.state == 1){
          if(val === "AuthCompanyPrice"){
            self.showPrice = result.data
            if(result.data != "True"){
              self.GetSystemConfigure("PriceText")
            }
          }
          if(val === "PriceText"){
            self.showPriceText = result.data
          }
        }
      })
    },

    sendVCode() {
      let self = this;
      self.sendVCodeTime = 60;
      self.getCode();
      localStorage.setItem("sendvcodetime",60);
      let index = setInterval(() => {
        if (self.sendVCodeTime > 0) {
          localStorage.setItem("sendvcodetime",--self.sendVCodeTime);
        } else {
          clearInterval(index);

          localStorage.removeItem("sendvcodetime");
        }
      },1000);
    },
    getCode() {
      let self = this;
      self.$http.post(self.url.SendVerifyCodeForWeb,{
        SmsTemplateType: 7,
        Phone: self.UserPhone,
      }).then(result => {
        if (result.state == true) {
          self.$message.success("验证码已发送成功");
        } else {
          self.$message.error(result.message);
        }
      });
    },
    SavePhone() {
      let self = this;
      if (self.VCode == "") {
        self.$message.error("请输入验证码");
        return;
      }
      self.$http.post(self.url.CheckVerifyCodeForProductPassTime,{
        Phone: self.UserPhone,
        VCode: self.VCode,
      }).then(result => {
        if (result.state == true) {
          self.$message.success("验证成功");
          self.dialogVisible = false;
          self.GetPagingProductInfoForWebFun();
        } else {
          self.$message.error(result.message);
          return;
        }
      });
    },
    toBuy(pro) {
      if (pro.Price != 0) {
        if (pro.BusinessType == 3) {
          this.turnTo("/Menu/detail2",pro);
        } else {
          this.turnTo("/Menu/detail",pro);
        }
      }
    },
    turnTo(url,pro) {
      if (pro) {
        this.$router.push({
          path: url,
          query: {id: pro.ProductId,w: pro.WarehouseId},
        });
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    orderByList(a) {
      let self = this;
      self.form.PriceSortType = a;
      self.currentpage = 1;
      self.GetPagingProductInfoForWebFun();
    },
    search() {
      let self = this;
      self.currentpage = 1;
      self.GetPagingProductInfoForWebFun();
    },
    reloadP(v) {
      let self = this;
      if (v) {
        self.WarHouseOption.forEach(item => {
          if (item.Attributes == v) {
            self.form.WareHouseId = item.value;
          }
        });
      } else {
        self.form.WareHouseId = "";
      }

      self.reload();
    },
    reload() {
      let self = this;
      self.currentpage = 1;
      self.form.Keyword = "";
      self.GetPagingProductInfoForWebFun();
    },
    cannalIT() {
      let self = this;
      self.dialogVisible = false;
      self.productList = [];
      self.TotalCount = 0;
    },
    // 业务类型change
    changeBusiness() {
      let self = this;
      self.currentpage = 1;
      self.VCode = "";
      self.form.Keyword = "";
      self.form.MaterielTypeId = "";
      if (self.form.BusinessType == 3) {
        self.$http.post(self.url.CheckProductPassTimeForWeb,{}).then(result => {
          if (result.state == true && result.data == "") {
            self.GetPagingProductInfoForWebFun();
          } else if (result.state == true && result.data != "") {
            self.dialogVisible = true;
            self.UserPhone = result.data;

          } else if (result.state == false) {
            self.$message.error(result.message);
          }
        });
      } else {
        self.GetPagingProductInfoForWebFun();
      }

    },
    getPic(item) {
      if (item.PictureUrl) {
        return SZH.assets.image + "/" + item.PictureUrl;
      } else {
        return "";
      }
    },
    onCurrentChange(v) {
      this.currentpage = v;
      this.GetPagingProductInfoForWebFun();
    },
    getWarehouseFun() {
      let self = this;
      self.$http.post(self.url.getWarehouseUrl,{})
        .then(result => {
          if (result.state == true) { // 注册成功
            self.WarHouseOption = result.data;
            self.WarHouseOption.forEach(item => {
              if (item.Attributes == "2000") {
                self.form.WareHouseId = item.value;
              }
            });
          } else {
            self.WarHouseOption = [];
          }
        },() => {
          // 请求失败
          self.$message.error("查询失败，请检查您的网络是否可用。");
        });
    },
    GetSelectProductMaterielTypeForWebFun() {
      let self = this;
      self.$http.post(self.url.GetSelectProductMaterielTypeForWebUrl,{
        Data: {
          KeyValue: "",
        },
      })
        .then(result => {
          if (result.state == true) {
            self.MaterielTypeOption = result.data;
          } else {
            self.MaterielTypeOption = [];
          }
        },() => {
          // 请求失败
          self.$message.error("查询失败，请检查您的网络是否可用。");
        });
    },
    GetSelectProductMaterielForWebFun() {
      let self = this;
      self.$http.post(self.url.GetSelectProductMaterielForWebUrl,{
        Data: {
          KeyValue: "",
        },
      })
        .then(result => {
          if (result.state == true) {
            self.MaterielOption = result.data;
          } else {
            self.MaterielOption = [];
          }
        },() => {
          // 请求失败
          self.$message.error("查询失败，请检查您的网络是否可用。");
        });
    },
    GetBusinessOptions() {
      let self = this;
      // SelectItems
      self.$http.post(self.url.GetSelectProductBusinessType,{}).then(result => {
        if (result.state == true && result.data && result.data.length > 0) {
          let arrList1 = result.data;
          self.$http.post(self.url.SelectItems,{
            keyValue: "BTypes",
          }).then(res => {
            if (res.state == true && res.data && res.data.length > 0) {
              let arrList2 = res.data;
              arrList1.forEach(h => {
                arrList2.forEach(v => {
                  if (h.value === v.value) {
                    h.label = v.label;
                  }
                });
              });
              self.BusinessOptions = arrList1
              self.form.BusinessType = result.data[0].value;
            }else{
              self.BusinessOptions = [];
            }

          });
          // self.BusinessOptions = result.data;
          // self.form.BusinessType = result.data[0].value;
          // console.log(self.form);
        } else {
          self.BusinessOptions = [];
          self.form.BusinessType = result.data[0].value;
        }
        self.GetPagingProductInfoForWebFun();

      });
    },
    GetPagingProductInfoForWebFun() {
      let self = this;
      self.fullscreenLoading = true;
      console.log(self.form);
      self.$http.post(self.url.GetPagingProductInfoForWebUrl,{
        Data: self.form,
        PageIndex: self.currentpage,
        PageSize: self.pageSize,
      })
        .then(result => {
          if (result.state == true) {
            self.productList = result.data.Data;
            self.TotalCount = result.data.TotalCount;
          } else {
            self.$message.error(result.message?result.message:'未查到数据');
            self.productList = [];
            self.TotalCount = 0;
          }
          self.fullscreenLoading = false;
        },() => {
          // 请求失败
          self.$message.error("查询失败，请检查您的网络是否可用。");
          self.fullscreenLoading = false;
        });
    },
  },
  computed: {},
  components: {},
  mounted() {
    this.getWarehouseFun();
    this.GetBusinessOptions();
    this.GetSelectProductMaterielTypeForWebFun();
    this.GetSelectProductMaterielForWebFun();
    this.GetCustomAuthType();
    // this.GetPagingProductInfoForWebFun();
  },
};



// WEBPACK FOOTER //
// ./src/views/Products/Products.js